export enum Resize {
  VERTICAL = 'vertical',
  NONE = 'none',
}

export enum TextareaMaxCharPosition {
  LEFT = 'left',
  RIGHT = 'right',
}

export type TextareaBorderRadius = 'small' | 'large';

export type TextareaPadding = 'default' | 'compact' | 'none';

export type TextAreaClearContentButtonPosition = 'left' | 'right';

export interface TextareaSelection {
  readonly selectionStart: number;
  readonly selectionEnd: number;
  readonly selectionContent: string;
}

export interface TextareaSelectEvent {
  readonly selection: TextareaSelection;
}
